import React, { useState, Fragment, useEffect } from 'react';
import { bool, element, func } from 'prop-types';
import { getGridConfig, getIcon } from './layout-two-vertical-grids-util.js';

const LayoutTwoVerticalGrids = ({
   isExpanded,
   leftComponent,
   rightComponent,
   isCorePricing,
   handleStatusLeftSideLayout,
}) => {
   const [isLeftGridCollapsed, setIsLeftGridCollapsed] = useState(isExpanded);

   const {
      leftGridWidth,
      rightGridWidth,
      leftContainerCss,
      rightContainerCss,
   } = getGridConfig(isLeftGridCollapsed, isCorePricing);
   const buildIcon = getIcon(setIsLeftGridCollapsed);
   useEffect(() => {
      handleStatusLeftSideLayout &&
         handleStatusLeftSideLayout(isLeftGridCollapsed);
   }, [isLeftGridCollapsed]);
   useEffect(() => {
      setIsLeftGridCollapsed(isExpanded);
   }, [isExpanded]);
   return (
      <div className='layout-two-vertical-grids'>
         {!isLeftGridCollapsed && (
            <div
               className='row spark-pull-left'
               style={{ width: `${leftGridWidth}%` }}
            >
               {!isExpanded && (
                  <span className='icon-toggle icon-toggle--expand'>
                     {buildIcon(isLeftGridCollapsed)}
                  </span>
               )}
            </div>
         )}
         <div
            className='spark-pull-left'
            style={{ width: `${rightGridWidth}%` }}
         >
            <div className={`row ${isCorePricing && 'justify-content'}`}>
               <div className={`${leftContainerCss} left-content`}>
                  <span
                     className={`${isLeftGridCollapsed ? '' : 'spark-hidden'}`}
                  >
                     {leftComponent}
                  </span>
                  {isExpanded && (
                     <button
                        className={`icon-toggle ${
                           isCorePricing && 'icon-toggle--collapse-bg'
                        } ${
                           isLeftGridCollapsed
                              ? 'icon-toggle--expand'
                              : 'icon-toggle--collapse'
                        }`}
                     >
                        {buildIcon(isLeftGridCollapsed)}
                     </button>
                  )}
               </div>

               <div className={`${rightContainerCss} right-content`}>
                  {rightComponent}
               </div>
            </div>
         </div>
      </div>
   );
};

LayoutTwoVerticalGrids.propTypes = {
   isExpanded: bool,
   leftComponent: element,
   rightComponent: element.isRequired,
   isCorePricing: bool,
   handleStatusLeftSideLayout: func,
};

export default LayoutTwoVerticalGrids;
